import React from 'react'
import JCards from './JCards'
import Mail from '../assests/Mail.png'
import picture from '../assests/picture.png'
import camera from '../assests/camera.png'
import laptop from '../assests/laptop.png'
import vector from '../assests/vector.png'
function Journey() {
  return (
    <div className='lg:h-auto 100vw bg-gradient-to-br from-[#001002] via-[#000000] to-[#001002] Journey'>
      <div className='h-full md:max-w-[1250px] m-auto md:flex md:flex-col md:justify-evenly'>

        <div className='flex justify-center py-6 md:p-0 px-4 md:px-0'>
          <div className='py-11 text-center ellipse  '>
            <h1 className='text-white font-normal text-3xl ml-12'>
              Ready to Ignite Your Brand's Digital Journey?
            </h1>
          </div>
        </div>

        <div className='grid sm:grid-cols-1 md:grid-cols-2 
                                lg:grid-cols-4 gap-4 text-white p-3'>

          <JCards  icon={<img className='mx-auto' src={Mail} alt="" />}
            heading='Get in Touch'
            text='Reach out via email to start the journey.
         Share a brief about your project and expectations.'/>

          <JCards icon={<img className='mx-auto' src={camera} alt="" />}
            heading='Set Up a Call'
            text="Schedule a consultation call with us. 
        Let's dive into your ideas, goals, and project specifics."/>

          <JCards icon={<img className='mx-auto' src={picture} alt="" />}
            heading='Share Assets'
            text="Provide us with images, texts,
         and any brand assets you want to incorporate. Your touch, our expertise."/>

          <JCards icon={<img className='mx-auto' src={laptop} alt="" />}
            heading='Review & Approve'
            text="Await your website taking shape. 
        Review the design and functionalities, making sure it's just as you envision."/>
        </div>

        <div>
          <img src={vector} alt="" srcset="" />
        </div>
      

      </div>

      <div className='w-full h-full py-16 px-5 wave bg-cover'>
          <div className=' w-auto md:w-[500px]  py-7 flex flex-col  border gap-7 box mx-auto  
           text-center text-white '>
            <h1 className='text-2xl md:3xl'>Ready for the Next Jump?</h1>
            <div>  <input className='text-white text-center py-3 px-5 bg-black rounded-md ' type="email" name="" id="" placeholder='youremail@xyz.com' />  </div>
            <div>   <button
              className='py-2 md:py-2 px-8 bg-black text-white'
              type="submit">Submit</button>  </div>
          </div>
        </div>

    </div>
  )
}

export default Journey